import { CountriesStore } from '../stores/countries';
import { getStoreFeatureFlags } from './profile';
import { setUiTotal } from './ui';
import { cleanZonesStore, getZonesSelect } from './zones';
import { IBodyListResponse, apiManager } from '../REST';
import {
    ICountriesList,
    ICountriesListItemAPI,
    ICountriesListItemNewAPI,
    ICountriesListNewAPI,
    IItemAPI,
    IParamsList,
    IRelationshipItem,
    ISelectCountries,
} from '../interfaces';
import { mapApi2UiField, sortByName } from '../instruments';

export function setCountriesSelect(list: ISelectCountries[]): void {
    const CountriesStoreInstance = CountriesStore.getInstance();
    CountriesStoreInstance.setCountriesSelect(list);
}

export function setCountriesWithZoneList(data: IItemAPI[]): void {
    // ToDo: 29.01.2026 -  remove after implement newResponseFormatCountries feature flag
    const CountriesStoreInstance = CountriesStore.getInstance();
    const list = data
        .map((i) => {
            return {
                id: i.id,
                name: i.attributes.name,
                zoneId: (i.relationships?.zone?.data as IRelationshipItem)?.id,
            };
        })
        .sort(sortByName);
    CountriesStoreInstance.setCountriesWithZoneList(list);
}

export function setCountriesForcedUpdateTime(): void {
    const CountriesStoreInstance = CountriesStore.getInstance();
    CountriesStoreInstance.setForcedUpdateTime();
}

export function getCountriesRelationSelect(): void {
    getZonesSelect();
}
export function setCountriesList(list: ICountriesList): void {
    const CountriesStoreInstance = CountriesStore.getInstance();
    CountriesStoreInstance.setCountriesList(list);
}

const mapCountriesListOld = (resp: IBodyListResponse): ICountriesList => {
    const { data, included } = resp;
    return (
        (data as ICountriesListItemAPI[]).map((c: ICountriesListItemAPI) => {
            const foundZone = included?.find((z) => z.id === c.relationships?.zone?.data?.id);
            return {
                id: c.id,
                ...mapApi2UiField(c.attributes || {}),
                name: c.attributes?.name || c.id.toString(),
                zoneId: c.relationships?.zone?.data?.id,
                zone: foundZone?.attributes?.name,
            };
        }) || []
    );
};
const mapCountriesListNew = (countries: ICountriesListItemNewAPI[]): ICountriesList => {
    return (
        countries?.map((c) => ({
            ...mapApi2UiField(c),
            id: c.id.toString(),
            name: c.name || c.id.toString(),
            zoneId: c.zone?.id.toString(),
            zone: c.zone?.name,
        })) || []
    );
};

export async function getCountriesList(params: IParamsList, isSelect?: boolean): Promise<void> {
    const { newResponseFormatCountries } = getStoreFeatureFlags();
    const searchParamsList: IParamsList = { ...params };
    if (isSelect) {
        searchParamsList.paginate = 'false';
    }
    const { resp } = await apiManager.getApi('GET_COUNTRIES_LIST', { searchParamsList });
    if (newResponseFormatCountries) {
        const { countries } = resp as ICountriesListNewAPI;
        const list = mapCountriesListNew(countries);
        if (isSelect) {
            setCountriesSelect(list);
        } else {
            setCountriesList(list);
            const { meta } = resp;
            meta && setUiTotal(meta.records_count);
        }
    } else {
        setCountriesList(mapCountriesListOld(resp as IBodyListResponse));
        const { meta } = resp;
        meta && setUiTotal(meta.records_count);
    }
}
// ToDo: 29.01.2026 -  remove these checks after implement newResponseFormatCountries feature flag
// ToDo: 27.01.2026 -  check - http://localhost:3000/purchase_rate_lists/new
// ToDo: 27.01.2026 -  check - http://localhost:3000/companies/1/edit
// ToDo: 27.01.2026 -  check - http://localhost:3000/packages/130/edit

export async function getCountriesWithZoneList(params: IParamsList = {}): Promise<void> {
    // ToDo: 29.01.2026 -  remove after implement newResponseFormatCountries feature flag
    const { newResponseFormatCountries } = getStoreFeatureFlags();
    if (newResponseFormatCountries) {
        await getCountriesList(params, true);
    } else {
        const { resp } = await apiManager.getApi('GET_COUNTRIES_SELECT', { searchParamsList: params });
        const { data } = resp as IBodyListResponse;
        data && setCountriesWithZoneList(data);
    }
}

export async function getCountriesSelect(params: IParamsList = {}): Promise<void> {
    const { newResponseFormatCountries } = getStoreFeatureFlags();
    if (newResponseFormatCountries) {
        await getCountriesList(params, true);
    } else {
        const { resp } = await apiManager.getApi('GET_COUNTRIES_SELECT', { searchParamsList: params });
        const { data } = resp as IBodyListResponse;
        const list: ISelectCountries[] =
            data
                ?.map((i) => {
                    return { id: i.id, name: i.attributes?.name || i.id, mcc: i.attributes?.mcc };
                })
                .sort(sortByName) || [];
        setCountriesSelect(list);
    }
}

export async function deleteCountry(id: string): Promise<void> {
    const { isError } = await apiManager.getApi('DELETE_COUNTRY', { id });
    if (!isError) {
        setCountriesForcedUpdateTime();
    }
}

export function cleanCountriesStore(): void {
    const CountriesStoreInstance = CountriesStore.getInstance();
    CountriesStoreInstance.cleanStore();
}
export function cleanCountriesRelationSelectAndStore(): void {
    cleanZonesStore();
}
export const getZoneIdByCountryIt = (id: string): string | undefined => {
    const { newResponseFormatCountries } = getStoreFeatureFlags();
    const CountriesStoreInstance = CountriesStore.getInstance();
    const country = (
        newResponseFormatCountries ? CountriesStoreInstance.select : CountriesStoreInstance.countriesWithZoneList
    ).find((i) => i.id === id);
    return country?.zoneId;
};
